import SplashManage from '../pages/advertisement/SplashManage.vue';
import InitPopup from '../pages/advertisement/InitPopup';
import MainBannerManage from '@/pages/advertisement/MainBannerManage.vue';
import MainBannerRegister from '@/pages/advertisement/MainBannerRegister.vue';
import AdsList from '../pages/advertisement/AdsList.vue';
import EditorProductList from '@/pages/advertisement/EditorProductList';
import MonthlyProductList from '@/pages/advertisement/MonthlyProductList';
import EventAd from '@/pages/advertisement/ad';
import MainLineBanner from '@/pages/advertisement/MainLineBanner';
import EventLineBanner from '@/pages/advertisement/EventLineBanner';
import ProductLineBanner from '@/pages/advertisement/ProductLineBanner';
import MainLineRegister from '@/pages/advertisement/MainLineRegister';
import EventLineRegister from '@/pages/advertisement/EventLineRegister';
import ProductLineRegister from '@/pages/advertisement/ProductLineRegister';
import MainLineModify from '@/pages/advertisement/MainLineModify';
import ProductLineModify from '@/pages/advertisement/ProductLineModify';
import EventLineModify from '@/pages/advertisement/EventLineModify';
import BrandRecommendManage from '@/pages/advertisement/BrandRecommendManage.vue';
import BrandRecommendRegister from '@/pages/advertisement/BrandRecommendRegister.vue';
import BrandRecommendModify from '@/pages/advertisement/BrandRecommendModify.vue';

export default {
	SplashManage: {
		id: 'SplashManage',
		title: '스플래시 관리',
		heading: '스플래시 관리',
		path: '/advertisement/splash-manage',
		component: SplashManage,
	},
	InitPopup: {
		id: 'InitPopup',
		title: '팝업배너 관리',
		heading: '팝업배너 관리',
		path: '/advertisement/init-popup/management',
		component: InitPopup,
	},
	MainBannerManage: {
		id: 'MainBannerManage',
		title: '메인배너 관리',
		heading: '메인배너 관리',
		path: '/advertisement/main-banner-manage',
		component: MainBannerManage,
	},
	MainBannerRegister: {
		id: 'MainBannerRegister',
		title: '메인배너 등록',
		heading: '메인배너 등록',
		path: '/advertisement/main-banner-register',
		component: MainBannerRegister,
	},
	AdsList: {
		id: 'AdsList',
		title: '광고 컨텐츠 집계 현황',
		heading: '광고 컨텐츠 집계 현황',
		path: '/advertisement/ads-list',
		component: AdsList,
	},
	EditorProductList: {
		id: 'EditorProductList',
		title: '추천제품 관리',
		heading: '추천제품 관리',
		path: '/advertisement/editor-product/list',
		component: EditorProductList,
	},
	MonthlyProductList: {
		id: 'MonthlyProductList',
		title: '인기 신제품 관리',
		heading: '인기 신제품 관리',
		path: '/advertisement/monthly-product',
		component: MonthlyProductList,
	},
	EventAd: {
		id: 'EventAd',
		title: '이벤트광고 관리',
		heading: '이벤트광고 관리',
		path: '/advertisement/ad',
		component: EventAd,
		type: 'v-app',
	},
	MainLineBanner: {
		id: 'MainLineBanner',
		title: '홈DA 관리',
		heading: '홈DA 관리',
		path: '/advertisement/line-banner',
		component: MainLineBanner,
	},
	EventLineBanner: {
		id: 'EventLineBanner',
		title: '이벤트 띠배너 관리',
		heading: '이벤트 띠배너 관리',
		path: '/advertisement/event-line-banner',
		component: EventLineBanner,
	},
	ProductLineBanner: {
		id: 'ProductLineBanner',
		title: '제품상세 띠배너 관리',
		heading: '제품상세 띠배너 관리',
		path: '/advertisement/product-line-banner',
		component: ProductLineBanner,
	},
	MainLineRegister: {
		id: 'MainLineRegister',
		title: '홈DA 등록',
		heading: '홈DA 등록',
		path: '/advertisement/line-banner-register',
		component: MainLineRegister,
	},
	EventLineRegister: {
		id: 'EventLineRegister',
		title: '이벤트 띠배너 등록',
		heading: '이벤트 띠배너 등록',
		path: '/advertisement/event-line-register',
		component: EventLineRegister,
	},
	ProductLineRegister: {
		id: 'ProductLineRegister',
		title: '제품상세 띠배너 등록',
		heading: '제품상세 띠배너 등록',
		path: '/advertisement/product-line-register',
		component: ProductLineRegister,
	},
	MainLineModify: {
		id: 'MainLineModify',
		title: '홈DA 수정',
		heading: '홈DA 수정',
		path: '/advertisement/line-banner-modify/:idParam',
		component: MainLineModify,
	},
	EventLineModify: {
		id: 'EventLineModify',
		title: '이벤트 띠배너 수정',
		heading: '이벤트 띠배너 수정',
		path: '/advertisement/event-line-modify/:idParam',
		component: EventLineModify,
	},
	ProductLineModify: {
		id: 'ProductLineModify',
		title: '제품상세 띠배너 수정',
		heading: '제품상세 띠배너 수정',
		path: '/advertisement/product-line-modify/:idParam',
		component: ProductLineModify,
	},
	BrandRecommendManage: {
		id: 'BrandRecommendManage',
		title: '추천브랜드 관리',
		heading: '추천브랜드 관리',
		path: '/advertisement/brand-recommend',
		component: BrandRecommendManage,
	},
	BrandRecommendRegister: {
		id: 'BrandRecommendRegister',
		title: '추천브랜드 등록',
		heading: '추천브랜드 등록',
		path: '/advertisement/brand-recommend-register',
		component: BrandRecommendRegister,
	},
	BrandRecommendModify: {
		id: 'BrandRecommendModify',
		title: '추천브랜드 수정',
		heading: '추천브랜드 수정',
		path: '/advertisement/brand-recommend-modify/:idParam',
		component: BrandRecommendModify,
	},
};
